import { inject, Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { interval, map, Observable, switchMap } from 'rxjs';

import { Rates } from '../../entities/rates';
import { RatesDataService } from '../../services/rates-data.service';

export interface MenuInfoStoreState {
    rates: Rates | null;
}

const initialState: MenuInfoStoreState = {
    rates: null
};

@Injectable()
export class MenuInfoStore extends ComponentStore<MenuInfoStoreState> {
    private readonly ratesDataService = inject(RatesDataService);

    readonly rates$ = this.select((state) => state.rates);

    readonly loadRates = this.effect((params$: Observable<void>) =>
        params$.pipe(
            switchMap(() =>
                this.ratesDataService.getRates().pipe(map((response) => this.patchState({ rates: response.rates })))
            )
        )
    );

    readonly pollRates = this.effect((params$: Observable<void>) =>
        params$.pipe(
            switchMap(() =>
                interval(60000).pipe(
                    switchMap(() =>
                        this.ratesDataService
                            .getRates()
                            .pipe(map((response) => this.patchState({ rates: response.rates })))
                    )
                )
            )
        )
    );

    constructor() {
        super(initialState);
    }
}
